// 组件类
import {
  Component,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'rs-footer',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
})
export class RSFooterComponent implements OnInit {
  today = new Date();
  ngOnInit() {
  }
}
